import React, { Component } from "react";
import { NavLink } from "react-router-dom";

import { ContentBlock } from "../../pages/components";
import Table from "../../common/components/Table";
import { Localize } from "../../../locale/localization";
import { formatDate } from "../../../utils/date-utils";

class ContentList extends Component {
  renderRow = item => {
    const { type } = this.props;
    const { _id, createdAt, category, name } = item;

    return (
      <tr key={_id}>
        <td>{formatDate(createdAt)}</td>
        <td>{category}</td>
        <td>
          <NavLink to={`/${type}/${_id}`}>{name}</NavLink>
        </td>
      </tr>
    );
  };

  render() {
    const { items, type, title, isArchive = false, widths = null } = this.props;
    return (
      <ContentBlock title={title}>
        <Table items={items} renderItem={this.renderRow} widths={widths} />
        {!isArchive && (
          <footer>
            <NavLink to={`/${type}/archive`}>{Localize("news.all")}</NavLink>
          </footer>
        )}
      </ContentBlock>
    );
  }
}

export default ContentList;



// WEBPACK FOOTER //
// ./src/modules/content/components/ContentList.js